<div [ngClass]="inline ? 'flex items-center gap-2' : 'flex flex-col items-start gap-2 h-full'">
  <label (click)="$event.stopPropagation();toggleValue()" class="cursor-pointer text-sm font-medium text-gray-700 select-none dark:text-gray-400">
    {{ label }}
  </label>
  <div class="relative mt-auto">
    <input type="checkbox" class="absolute opacity-0 w-full h-full cursor-pointer" [formControl]="control">
    <div
      (click)="$event.stopPropagation();toggleValue()"
      class="block cursor-pointer h-6 w-11 rounded-full bg-brand-500 dark:bg-brand-500"
      [ngClass]="control.value ? 'bg-brand-500 dark:bg-brand-500' : 'bg-gray-200 dark:bg-white/10'"></div>
    <div
      (click)="$event.stopPropagation();toggleValue()"
      [ngClass]="control.value ? 'translate-x-full' : 'translate-x-0'"
      class="shadow-theme-sm cursor-pointer absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white duration-300 ease-linear"></div>
  </div>
</div>
@if (control.invalid && (control.dirty || control.touched)) {
  <p class="text-theme-xs text-error-500 mt-1.5">
    @for (errorKey of control.errors ? Object.keys(control.errors) : []; track errorKey) {
      @if (control.errors) {
        <div>{{ errorKey | errorMessage:control.errors[errorKey] }}</div>
      }
    }
  </p>
}
